import { render, staticRenderFns } from "./ActivateMyCard.vue?vue&type=template&id=0efa7aec&"
import script from "./ActivateMyCard.vue?vue&type=script&lang=js&"
export * from "./ActivateMyCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports